const apiUrl = () => import.meta.env.VITE_FORM_API_URL as string;
const token = () => import.meta.env.VITE_FORMS_API_TOKEN as string;

export async function sendWebengageCTAEvents(payload: {
  form_id: number;
  email: string;
  name: string;
  phone: string;
}): Promise<void> {
  if (!apiUrl() || !token() || !payload.email) return;
  await fetch(`${apiUrl()}/webengage/application-form/cta-click`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token()}`,
    },
    body: JSON.stringify(payload),
  }).catch(() => {});
}
